import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/services/query-keys';
import { useAuthStore } from '@/shared/stores/auth-store';
import { fetchDashboardAnalytics, fetchCampaignAnalytics } from './analytics-api';
import type { DateRangePreset } from '../types/analytics.types';

function presetToDateRange(preset: DateRangePreset): { startDate: string; endDate: string } {
  const end = new Date();
  const start = new Date();
  const days = preset === '7d' ? 7 : preset === '30d' ? 30 : 90;
  start.setDate(start.getDate() - days);

  return {
    startDate: start.toISOString().slice(0, 10),
    endDate: end.toISOString().slice(0, 10),
  };
}

export function useDashboardAnalytics(preset?: DateRangePreset) {
  const orgId = useAuthStore((state) => state.orgId);
  const dateRange = preset ? presetToDateRange(preset) : undefined;

  return useQuery({
    queryKey: queryKeys.analytics.dashboard({ organizationId: orgId, preset }),
    queryFn: () => fetchDashboardAnalytics(orgId!, dateRange),
    enabled: !!orgId,
  });
}

export function useCampaignAnalytics(id: string, preset?: DateRangePreset) {
  const dateRange = preset ? presetToDateRange(preset) : undefined;
  const keyRange = dateRange ? { start: dateRange.startDate, end: dateRange.endDate } : undefined;

  return useQuery({
    queryKey: queryKeys.analytics.campaign(id, keyRange),
    queryFn: () => fetchCampaignAnalytics(id, dateRange),
    enabled: !!id,
  });
}
